import { environment } from '@web/config';

const SERVICE_WORKER_PATH = '/sw.js';

// Mirrors the Angular gate (stage/prod) plus local for testing. dev and int never register.
const SERVICE_WORKER_MODES = ['local', 'stage', 'prod', 'int', 'dev', 'externaldev', 'externalint', 'externalstage', 'externalprod'];

export function isServiceWorkerAllowed(): boolean {
  console.log(import.meta.env.VITE_ENV );
  console.log(import.meta.env.MODE);
  console.log(import.meta.env.VITE_ENV as string);
  return SERVICE_WORKER_MODES.includes(environment.upstreamEnv);
}

/**
 * Registers or re-registers the application service worker when
 * environment.serviceWorkerEnabled is true and the build mode allows it.
 * When the flag is false the function returns without touching an existing registration.
 */
export async function registerAppServiceWorker(): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  if (environment.serviceWorkerEnabled !== true || !isServiceWorkerAllowed()) {
    return;
  }

  try {
    await navigator.serviceWorker.register(SERVICE_WORKER_PATH);
  } catch {
    // Registration failure must never block application startup.
  }
}
